import { Link } from 'react-router-dom';
import { ExternalLink } from 'lucide-react';
import { entityPath, type SlotReference } from '@the-real-insight/tri-model';
import { knownEntityType } from './entityTypes';
import { useReferenceLabel } from '../portfolio-dashboard/referenceLabel';

/**
 * Eine Entität, verlinkt auf ihre Seite — für jeden Typ dieselbe Adresse (`/entities/:type/:id`).
 *
 * Ohne übergebenen Namen wird er nachgeschlagen („Walther-von-Cronberg-Platz 11 — …“ statt „Grundstück 5fe437“).
 * Bis er da ist, oder wenn es keinen gibt, steht da, was sicher stimmt: die Art und das Ende der Kennung.
 */
export function EntityLink({ reference, label }: { reference: SlotReference; label?: string }) {
    const looked = useReferenceLabel(label ? null : reference);
    const known = knownEntityType(reference.type) as any;
    const kind = known?.type?.label?.de ?? reference.type;
    return (
        <Link to={entityPath(reference)} className="inline-flex items-center gap-1 text-primary underline-offset-2 hover:underline">
            {label || looked || `${kind} ${String(reference._id).slice(-6)}`}
            <ExternalLink className="h-3 w-3" aria-hidden />
        </Link>
    );
}

export default EntityLink;
